import { gql } from '@apollo/client';

import { GetNewsArticles } from './__generated__/getNewsArticles';

// newsArticles(sort: NewsSort!, filters: [NewsFilter!], pagination: Pagination): [NewsArticle!]!

// Shared by every consumer of this query's `newsArticles` selection -- centralized here, next to
// the query that produces it, instead of each consumer re-deriving an identical alias.
export type NewsArticle = NonNullable<NonNullable<GetNewsArticles>['newsArticles']>[number];

const GET_NEWS_ARTICLES = gql`
  query GetNewsArticles($sort: NewsSort!, $filters: [NewsFilter!], $pagination: Pagination) {
    newsArticles(sort: $sort, filters: $filters, pagination: $pagination) {
      id
      publication_date
      subject
      url
      sentiment_score
      summary
      news_category
      news_source
    }
  }
`;

export { GET_NEWS_ARTICLES };
